"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.limitPageSize = exports.createSSEConfiguration = exports.createTournamentsReqV2 = exports.createTournamentsReq = exports.getTagIds = exports.getSportIds = exports.eventLivelinessToEnum = exports.eventLivelinessToBoolean = exports.probabilitiesVersionChanged = exports.probabilitiesChanged = exports.isEqualEventWithoutProbs = exports.searchRegExpReplaceFunc = exports.doesStringMatchSearchRegExp = exports.EVENT_STATUSES_TO_CLEAR_OUTCOMES = void 0;
exports.updateStateWithEvents = updateStateWithEvents;
exports.createGetEventsRequest = createGetEventsRequest;
exports.processSportIds = processSportIds;
exports.needToClearOutcomes = needToClearOutcomes;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const lodash_1 = require("lodash");
const effects_1 = require("redux-saga/effects");
const _reduxjs_1 = require("../../utils/@reduxjs");
const logger_1 = require("../../utils/logger");
const utils_1 = require("../ConfigProvider/utils");
const constants_1 = require("./constants");
const types_1 = require("../ConfigProvider/types");
const selectors_1 = require("../CommonDataProvider/selectors");
const saga_1 = require("../ConfigProvider/saga");
const utils_2 = require("../../api/events/utils");
exports.EVENT_STATUSES_TO_CLEAR_OUTCOMES = [
    betweb_openapi_axios_1.EventStatus.Closed,
    betweb_openapi_axios_1.EventStatus.Ended,
    betweb_openapi_axios_1.EventStatus.Cancelled,
    betweb_openapi_axios_1.EventStatus.Retired,
    betweb_openapi_axios_1.EventStatus.Interrupted,
];
// Function to replace specific text patterns before regex testing
const replaceTextInProbsSearch = (text) => text ? text.replaceAll(/{\$.*}/g, '') : text;
// Helper function to check if a string matches a search regexp after cleaning with replaceText
const doesStringMatchSearchRegExp = (str, searchRegExp) => searchRegExp.test(replaceTextInProbsSearch(str));
exports.doesStringMatchSearchRegExp = doesStringMatchSearchRegExp;
const searchRegExpReplaceFunc = (searchRegExp) => (text) => searchRegExp && text
    ? text.replace(searchRegExp, (str) => `<span>${str}</span>`)
    : text;
exports.searchRegExpReplaceFunc = searchRegExpReplaceFunc;
function updateStateWithEvents(state, events) {
    const shouldCompareEveryEvent = (0, utils_1.isFeatureFlagEnabled)(types_1.EFeatureFlags.PERFORMANCE_PLAT628);
    if (shouldCompareEveryEvent) {
        const start = Date.now();
        events.forEach((event) => {
            const oldEvent = state.events.entries[event.id];
            if (!oldEvent) {
                // not exist yet
                state.events.entries[event.id] = event;
            }
            else if (!(0, react_fast_compare_1.default)(oldEvent, event)) {
                // event is changed
                state.events.entries[event.id] = event;
            }
        });
        const timeTaken = Date.now() - start;
        (0, logger_1.logger)(`fetchEventsSuccess: ${timeTaken} milliseconds, events: ${events.length}`);
    }
    else {
        state.events.entries = {
            ...state.events.entries,
            ...(0, _reduxjs_1.toIdsMap)(events),
        };
    }
}
const isEqualEventWithoutProbs = (a, b) => {
    return (0, react_fast_compare_1.default)((0, lodash_1.omit)(a, ['probabilities']), (0, lodash_1.omit)(b, ['probabilities']));
};
exports.isEqualEventWithoutProbs = isEqualEventWithoutProbs;
const probabilitiesChanged = (a, b) => {
    return a.probabilities.timestamp !== b.probabilities.timestamp;
};
exports.probabilitiesChanged = probabilitiesChanged;
const probabilitiesVersionChanged = (a, b) => {
    return a.probabilities.version !== b.probabilities.version;
};
exports.probabilitiesVersionChanged = probabilitiesVersionChanged;
function* createGetEventsRequest(reqData, currentLangCode, topTagId, params) {
    const isEntityTagsEnabled = (0, utils_1.isFeatureFlagEnabled)(types_1.EFeatureFlags.ENTITY_TAGS_ENABLED);
    const newEventsEndpointEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_EVENTS_ENDPOINT);
    let request = {
        ...reqData,
        locale: currentLangCode,
    };
    if (isEntityTagsEnabled) {
        delete request.top;
        if (reqData.top && topTagId) {
            request = {
                ...request,
                tagIds: [topTagId],
                tagFilterOperation: betweb_openapi_axios_1.TagFilterOperation.Loose,
            };
        }
    }
    if (newEventsEndpointEnabled) {
        request = {
            ...request,
            sportIds: request.sportId ? [request.sportId] : request.sportIds,
            tournamentIds: request.tournamentId
                ? [request.tournamentId]
                : request.tournamentIds,
        };
        delete request.sportId;
        delete request.tournamentId;
    }
    if (params) {
        request = yield (0, effects_1.call)(processSportIds, request, params);
    }
    if (newEventsEndpointEnabled && request.fiql) {
        return (0, utils_2.omitEventsRequestNonFiqlFilters)(request);
    }
    return request;
}
const eventLivelinessToBoolean = (eventLiveliness) => {
    switch (eventLiveliness) {
        case betweb_openapi_axios_1.EventLiveliness.Live:
            return true;
        case betweb_openapi_axios_1.EventLiveliness.Line:
            return false;
        case betweb_openapi_axios_1.EventLiveliness.All:
        default:
            return undefined;
    }
};
exports.eventLivelinessToBoolean = eventLivelinessToBoolean;
const eventLivelinessToEnum = (eventLiveliness) => {
    if (eventLiveliness) {
        return betweb_openapi_axios_1.EventLiveliness.Live;
    }
    if (eventLiveliness === false) {
        return betweb_openapi_axios_1.EventLiveliness.Line;
    }
    return eventLiveliness;
};
exports.eventLivelinessToEnum = eventLivelinessToEnum;
const getSportIds = (sportId, sportIds) => {
    const ids = sportIds || [];
    if (sportId) {
        ids.push(sportId);
    }
    const uniqueIds = Array.from(new Set(ids));
    return uniqueIds.length ? uniqueIds : undefined;
};
exports.getSportIds = getSportIds;
const getTagIds = (tournamentTagIds, tagIds, topTagId, top) => {
    const ids = [...(tournamentTagIds || []), ...(tagIds || [])];
    if (topTagId && top) {
        ids.push(topTagId);
    }
    const uniqueIds = Array.from(new Set(ids));
    return uniqueIds.length ? uniqueIds : undefined;
};
exports.getTagIds = getTagIds;
const createTournamentsReq = (reqData, isGenericSportsEnabled, topTagId) => {
    const isEntityTagsEnabled = (0, utils_1.isFeatureFlagEnabled)(types_1.EFeatureFlags.ENTITY_TAGS_ENABLED);
    const tagIds = (0, exports.getTagIds)(reqData.tournamentTagIds, reqData.tagIds);
    const eventLiveliness = typeof reqData.eventLiveliness === 'boolean'
        ? (0, exports.eventLivelinessToEnum)(reqData.eventLiveliness)
        : reqData.eventLiveliness;
    const tagFilterOperation = reqData.tagFilterOperation || reqData.tournamentTagFilterOperation;
    const request = {
        ...reqData,
        tagIds,
        eventLiveliness,
        tagFilterOperation,
        includeSubsports: isGenericSportsEnabled || undefined,
    };
    delete request.tournamentTagFilterOperation;
    delete request.sportIds;
    delete request.tournamentTagIds;
    if (isEntityTagsEnabled) {
        delete request.top;
        if (reqData.top && topTagId) {
            request.tagIds = [topTagId];
            request.tagFilterOperation = betweb_openapi_axios_1.TagFilterOperation.Loose;
        }
    }
    return request;
};
exports.createTournamentsReq = createTournamentsReq;
// TODO write test
const createTournamentsReqV2 = (reqData, isGenericSportsEnabled, topTagId, currentLangCode) => {
    var _a;
    const tournamentTagIds = (0, exports.getTagIds)(reqData.tournamentTagIds, reqData.tagIds, topTagId, reqData.top);
    const sportIds = (0, exports.getSportIds)(reqData.sportId, reqData.sportIds);
    const eventLiveliness = typeof reqData.eventLiveliness !== 'boolean'
        ? (0, exports.eventLivelinessToBoolean)(reqData.eventLiveliness)
        : reqData.eventLiveliness;
    const tagFilterOperation = reqData.tournamentTagFilterOperation || reqData.tagFilterOperation;
    const tournamentTagFilterOperation = topTagId
        ? betweb_openapi_axios_1.TagFilterOperation.Loose
        : tagFilterOperation;
    const request = {
        ...reqData,
        eventLiveliness,
        tournamentTagIds,
        tournamentTagFilterOperation,
        sportIds,
        pageSize: (_a = reqData.pageSize) !== null && _a !== void 0 ? _a : constants_1.DEFAULT_PAGE_SIZE,
        includeSubsports: isGenericSportsEnabled || undefined,
        locale: currentLangCode,
    };
    delete request.top;
    delete request.tagFilterOperation;
    delete request.sportId;
    delete request.tagIds;
    return request;
};
exports.createTournamentsReqV2 = createTournamentsReqV2;
const createSSEConfiguration = (baseApiPath, { locale, cursor, topTagId, reloadIdsToSkip, }, isEntityTagsEnabled) => {
    const reloadIds = (reloadIdsToSkip === null || reloadIdsToSkip === void 0 ? void 0 : reloadIdsToSkip.length)
        ? `&reload-ids-to-skip=${reloadIdsToSkip}`
        : '';
    const tagConfig = isEntityTagsEnabled && topTagId
        ? `tag-ids=${[topTagId]}&tag-filter-operation=LOOSE`
        : 'top=true';
    return `${baseApiPath}/events/updates?locale=${locale}&cursor=${cursor}&${tagConfig}&cursor-reset-policy=${betweb_openapi_axios_1.CursorResetPolicy.Strict}${reloadIds}`;
};
exports.createSSEConfiguration = createSSEConfiguration;
function* processSportIds(reqData, params) {
    var _a;
    const newEventsEndpointEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.NEW_EVENTS_ENDPOINT);
    const isGenericEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, types_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
    if (newEventsEndpointEnabled && ((_a = reqData.sportIds) === null || _a === void 0 ? void 0 : _a.length)) {
        const expandedSportIds = yield (0, effects_1.select)((state) => reqData.sportIds.flatMap((id) => (0, selectors_1.selectChildrenSportIds)(state, id)));
        if (expandedSportIds.length) {
            return {
                ...reqData,
                sportIds: [...new Set([...reqData.sportIds, ...expandedSportIds])],
            };
        }
    }
    else if (reqData.sportId && params.includeSubsports && isGenericEnabled) {
        const childrenSportIds = yield (0, effects_1.select)((state) => (0, selectors_1.selectChildrenSportIds)(state, reqData.sportId));
        if (childrenSportIds.length) {
            return {
                ...reqData,
                sportId: undefined,
                sportIds: childrenSportIds,
            };
        }
    }
    return reqData;
}
const limitPageSize = (pageSize) => {
    if (!pageSize || pageSize < 0) {
        return {
            pageSize: constants_1.DEFAULT_PAGE_SIZE,
            remainder: 0,
        };
    }
    if (pageSize > constants_1.MAX_PAGE_SIZE) {
        return {
            pageSize: constants_1.MAX_PAGE_SIZE,
            remainder: pageSize - constants_1.MAX_PAGE_SIZE,
        };
    }
    return {
        pageSize,
        remainder: 0,
    };
};
exports.limitPageSize = limitPageSize;
/**
 *  Функция проверяет что событие находится в статусе при котором нельзя
 *  показывать исходы и делать на них ставки
 *
 * @param event - событие
 * @returns boolean - true - если необходимо удалить исходы
 */
function needToClearOutcomes(event) {
    return (exports.EVENT_STATUSES_TO_CLEAR_OUTCOMES.includes(event.status) ||
        !event.probabilities);
}
//# sourceMappingURL=utils.js.map